module.exports = __webpack_public_path__ + "img/EducationalScheduleTimeDetails.1e2fff04.svg";